export enum IndexJsonKeyPaths {
  LAYOUT = 'gauge.layout',
  MODE = 'gauge.mode.grid',
  MEKKA = 'model.mecca.visibility'
}

export enum Grid {
  FOUR_BY_FOUR = '4 x 1 x 4',
  THREE_BY_THREE = '3 x 1 x 3'
}

export type OvalSide = 'left' | 'right'

export type Gauge = { name: string }

export interface GaugeVisibility {
  order: number
  active: boolean
}

export type GaugesVisibility = {
  wind: GaugeVisibility
  speed: GaugeVisibility
  heading: GaugeVisibility
  temperature: GaugeVisibility
  depth: GaugeVisibility
  eco_score: GaugeVisibility
  pressure: GaugeVisibility
  time: GaugeVisibility
  mekkah: GaugeVisibility
  location: GaugeVisibility
}
